<div>confirmation-dialog component redesign - use the app-classic version of this component as a starting point</div>
